module.exports = __webpack_public_path__ + "static/media/default-pdf.a12936e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/default-pdf.png
// module id = ./src/theme/images/default-pdf.png
// module chunks = 1